// extracted by mini-css-extract-plugin
export default {"header":"header_header__z2nbC","image":"header_image__AY7OR"};